/**
 * iProtectYou.Family — React client entry point.
 *
 * Standard CRA client-side render (no prerendering — the app's pages are
 * transactional and noindexed; SEO/marketing lives on the WordPress site).
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';
import './index.css';

// ---- Sentry (browser) ----------------------------------------------------
const dsn = process.env.REACT_APP_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0, // record session replay on errors only
    replaysSessionSampleRate: 0.0, // no session replay otherwise
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  });
}

// ---- Root render ---------------------------------------------------------
const rootElement = document.getElementById('root');

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

ReactDOM.createRoot(rootElement).render(tree);

reportWebVitals();
